var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('check-box',_vm._b({model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},'check-box',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }